export const AML_SUCCESS_MODAL = 'AML_SUCCESS_MODAL';
export const COMPLETE_AML_MODAL = 'COMPLETE_AML_MODAL';
export const AML_QUIZ_FORM = 'AML_QUIZ_FORM';
export const AML_QUIZ_MODAL = 'AML_QUIZ_MODAL';
